import React, {useState} from 'react';
import {concatenate} from "services/string";

type Option = {
    id: string
    name: string
    disabled?: boolean
}

type Props = {
    children: Array<Option>
    selectedId: string
    onChange: (option: Option) => any
}

function ButtonGroup(props: Props) {
    const {children, selectedId, onChange} = props
    const [selected, setSelected] = useState<Option>(children.find(option => option.id === selectedId) || children[0]);

    function handleSelection(option: Option) {
        setSelected(option)
        onChange(option)
    }

    return (
        <span className="relative z-0 inline-flex shadow-sm rounded-md mb-1">
            {children.map((option, index) => (
                <button
                    key={index}
                    type="button"
                    onClick={() => handleSelection(option)}
                    disabled={!!option.disabled}
                    className={concatenate(
                        selected.id === option.id && 'border-transparent bg-brand hover:bg-gradient-white-overlay text-white',
                        selected.id !== option.id && !!option.disabled && 'bg-gray-200 border-gray-300 text-gray-400',
                        selected.id !== option.id && !option.disabled && 'border-gray-300 bg-white hover:bg-gray-50 text-gray-700',
                        index === 0? 'rounded-l-md' : (index === (children.length - 1)? 'rounded-r-md' : null),
                        'relative inline-flex items-center px-3 py-1 border text-sm font-medium focus:z-10 focus:outline-none focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-brand'
                    )}>
                    {option.name}
                </button>
            ))}
        </span>
    );
}

export default ButtonGroup;